import React, { Component } from "react";
import "./StyleView.css";
import "./Styler.css";

const baseClasses = ["Input", "Checkbox", "PrimaryButton", "SecondaryButton"];

const baseClassesAsCSS = [".input", ".checkbox", ".button", ".button.secondary"];

const pseudoClasses = ["", "Hover", "Focus"];

const pseudoClassesAsCSS = ["", ":hover:not(:disabled)", ":focus"];

const baseAttribsToOutput = [
  "appearance",
  "background-image",
  "background-color",
  "border-image",
  "box-shadow",
  "color",
  "font-size",
  "font-weight",
];

const borderAttribPrefixes = ["border-bottom", "border-left", "border-right", "border-top"];

const borderAttribsToOutput = ["-width", "-style", "-color"];

const borderRadiusAttribsToOutput = [
  "border-bottom-left-radius",
  "border-bottom-right-radius",
  "border-top-left-radius",
  "border-top-right-radius",
];

const paddingAttribsToOutput = ["padding-bottom", "padding-left", "padding-right", "padding-top"];

const outlineAttribsToOutput = ["outline-width", "outline-style", "outline-color"];

const flatValueAttribs = ["font-weight"];

class StyleView extends Component {
  constructor(props) {
    super(props);

    this.CSS = {};
  }

  componentDidMount() {
    this.getAllCSS();

    this.setState({
      mounted: true,
    });
  }

  handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  getAllBordersShorthand = (styleAttribs) => {
    return this.getBorderAttribShorthand(styleAttribs, "");
  };

  getBorderShorthand = (styleAttribs, borderName) => {
    const borderWidth = styleAttribs[borderName + "-width"];
    const borderStyle = styleAttribs[borderName + "-style"];
    const borderColor = styleAttribs[borderName + "-color"];

    if (borderWidth !== null && borderStyle !== null && borderColor !== null)
      if (borderWidth === 0) return "none";
      else return borderWidth + " " + borderStyle + " " + borderColor;

    return null;
  };

  getBorderAttribShorthand = (styleAttribs, attrib) => {
    const borderTopAttrib = styleAttribs["border-top" + attrib];
    const borderRightAttrib = styleAttribs["border-right" + attrib];
    const borderBottomAttrib = styleAttribs["border-bottom" + attrib];
    const borderLeftAttrib = styleAttribs["border-left" + attrib];

    if (
      borderTopAttrib !== null &&
      borderRightAttrib !== null &&
      borderBottomAttrib !== null &&
      borderLeftAttrib !== null
    ) {
      if (
        borderTopAttrib === borderRightAttrib &&
        borderTopAttrib === borderBottomAttrib &&
        borderTopAttrib === borderLeftAttrib
      )
        return borderTopAttrib;
    }

    return null;
  };

  getBorderRadiusShorthand = (styleAttribs) => {
    const topLeftBorder = styleAttribs["border-top-left-radius"];
    const topRightBorder = styleAttribs["border-top-right-radius"];
    const bottomRightBorder = styleAttribs["border-bottom-right-radius"];
    const bottomLeftBorder = styleAttribs["border-bottom-left-radius"];

    if (topLeftBorder !== null && topRightBorder !== null && bottomRightBorder !== null && bottomLeftBorder !== null) {
      if (topLeftBorder === topRightBorder && topLeftBorder === bottomRightBorder && topLeftBorder === bottomLeftBorder)
        return topLeftBorder;
      if (topLeftBorder === bottomRightBorder && topRightBorder === bottomLeftBorder)
        return topLeftBorder + " " + topRightBorder;
      else return topLeftBorder + " " + topRightBorder + " " + bottomRightBorder + " " + bottomLeftBorder;
    }

    return null;
  };

  getPaddingShorthand = (styleAttribs) => {
    const paddingTop = styleAttribs["padding-top"];
    const paddingRight = styleAttribs["padding-right"];
    const paddingBottom = styleAttribs["padding-bottom"];
    const paddingLeft = styleAttribs["padding-left"];

    if (paddingTop !== null && paddingRight !== null && paddingBottom !== null && paddingLeft !== null) {
      if (paddingTop === paddingRight && paddingTop === paddingBottom && paddingTop === paddingLeft) return paddingTop;
      else if (paddingTop === paddingBottom && paddingRight === paddingLeft) return paddingTop + " " + paddingLeft;
      else return paddingTop + " " + paddingRight + " " + paddingBottom + " " + paddingLeft;
    }

    return null;
  };

  getOutlineShorthand = (styleAttribs) => {
    const outlineWidth = styleAttribs["outline-width"];
    const outlineStyle = styleAttribs["outline-style"];
    const outlineColor = styleAttribs["outline-color"];

    if (outlineWidth !== null && outlineStyle !== null && outlineColor !== null)
      if (outlineWidth === 0) return "none";
      else return outlineWidth + " " + outlineStyle + " " + outlineColor;

    return null;
  };

  getElementCSS = (elementId) => {
    const getExpandedBorderAttribsToOutput = () => {
      let result = [];

      for (let i = 0; i < borderAttribPrefixes.length; i++)
        for (let j = 0; j < borderAttribsToOutput.length; j++)
          result.push(borderAttribPrefixes[i] + borderAttribsToOutput[j]);

      return result;
    };

    const clearAttribs = (styleAttribs, attribsToClear) => {
      let attrib = null;

      for (let i = 0; i < attribsToClear.length; i++) {
        attrib = attribsToClear[i];
        if (styleAttribs[attrib] !== null) styleAttribs[attrib] = null;
      }
    };

    const getStyleAttribs = (style, attribsToOutput) => {
      let attrib = null;
      let value = null;
      let parsedValue = null;
      let result = {};

      for (let i = 0; i < attribsToOutput.length; i++) {
        attrib = attribsToOutput[i];
        value = style.getPropertyValue(attrib);
        if (!value) continue;

        parsedValue = parseInt(value, 10);
        if (!isNaN(parsedValue) && !flatValueAttribs.includes(attrib)) {
          value = Math.round(parsedValue);
          if (value > 0) value = value + "px";
        }

        result[attrib] = value;
      }

      return result;
    };

    let elem = document.getElementById(elementId);
    let style = window.getComputedStyle(elem, null);
    let baseStyleAttribs = getStyleAttribs(style, baseAttribsToOutput);

    const expandedBorderAttribsToOutput = getExpandedBorderAttribsToOutput();

    let expandedAttribsToOutput = [].concat(
      expandedBorderAttribsToOutput,
      borderRadiusAttribsToOutput,
      paddingAttribsToOutput,
      outlineAttribsToOutput,
    );

    let expandedStyleAttribs = getStyleAttribs(style, expandedAttribsToOutput);

    let border = null;
    for (let i = 0; i < borderAttribPrefixes.length; i++) {
      border = borderAttribPrefixes[i];
      expandedStyleAttribs[border] = this.getBorderShorthand(expandedStyleAttribs, border);
    }

    let attrib = null;
    for (let i = 0; i < borderAttribsToOutput.length; i++) {
      attrib = borderAttribsToOutput[i];
      expandedStyleAttribs["border" + attrib] = this.getBorderAttribShorthand(expandedStyleAttribs, attrib);
    }

    let clearCompositeBorderAttribs = false;
    for (let i = 0; i < borderAttribPrefixes.length; i++) {
      border = borderAttribPrefixes[i];
      for (let j = 0; j < borderAttribsToOutput.length; j++) {
        attrib = borderAttribsToOutput[j];
        if (expandedStyleAttribs["border" + attrib] !== null || expandedStyleAttribs[border] !== null)
          expandedStyleAttribs[border + attrib] = null;
      }

      if (expandedStyleAttribs[border] !== null) clearCompositeBorderAttribs = true;
    }

    if (clearCompositeBorderAttribs)
      clearAttribs(
        expandedStyleAttribs,
        borderAttribsToOutput.map((item) => "border" + item),
      );

    expandedStyleAttribs["border"] = this.getAllBordersShorthand(expandedStyleAttribs);
    if (expandedStyleAttribs["border"] !== null) {
      clearAttribs(expandedStyleAttribs, borderAttribPrefixes);
      if (!clearCompositeBorderAttribs)
        clearAttribs(
          expandedStyleAttribs,
          borderAttribsToOutput.map((item) => "border" + item),
        );
    }

    expandedStyleAttribs["border-radius"] = this.getBorderRadiusShorthand(expandedStyleAttribs);
    if (expandedStyleAttribs["border-radius"] !== null) clearAttribs(expandedStyleAttribs, borderRadiusAttribsToOutput);

    expandedStyleAttribs["padding"] = this.getPaddingShorthand(expandedStyleAttribs);
    if (expandedStyleAttribs["padding"] !== null) clearAttribs(expandedStyleAttribs, paddingAttribsToOutput);

    expandedStyleAttribs["outline"] = this.getOutlineShorthand(expandedStyleAttribs);
    if (expandedStyleAttribs["outline"] !== null) clearAttribs(expandedStyleAttribs, outlineAttribsToOutput);

    const expandedStyleAttribsKeys = Object.keys(expandedStyleAttribs);

    let prunedStyleAttribs = {};
    let key = null;

    for (let i = 0; i < expandedStyleAttribsKeys.length; i++) {
      key = expandedStyleAttribsKeys[i];
      if (expandedStyleAttribs[key] !== null) prunedStyleAttribs[key] = expandedStyleAttribs[key];
    }

    let styleAttribs = { ...baseStyleAttribs, ...prunedStyleAttribs };

    return styleAttribs;
  };

  getAllCSS = () => {
    let baseClass = null;
    let pseudoClass = null;
    let className = null;

    for (let i = 0; i < baseClasses.length; i++) {
      baseClass = baseClasses[i];
      for (let j = 0; j < pseudoClasses.length; j++) {
        pseudoClass = pseudoClasses[j];

        className = baseClass + " " + pseudoClass;
        this.CSS[className] = {
          selector: baseClassesAsCSS[i] + pseudoClassesAsCSS[j],
          attribs: this.getElementCSS(className),
        };
      }
    }
  };

  renderCSS = (className, ancestors = []) => {
    const attribHasSameValueAsAncestors = (attrib) => {
      let ancestor = null;

      for (let i = 0; i < ancestors.length; i++) {
        ancestor = ancestors[i];
        if (this.CSS[ancestor] && this.CSS[ancestor].attribs[attrib] === this.CSS[className].attribs[attrib])
          return true;
      }

      return false;
    };

    if (!this.CSS[className]) return null;

    return (
      <div className="StyleAttribsDiv">
        <span className="StyleAttribSpan SecondaryText">
          <b>{this.CSS[className].selector + " {"}</b>
        </span>
        {Object.keys(this.CSS[className].attribs)
          .sort()
          .map((item, index) =>
            attribHasSameValueAsAncestors(item) ? null : (
              <span className="StyleAttribSpan Sub SecondaryText" key={index}>
                {"  "}
                <b>{item + ": "}</b>
                {this.CSS[className].attribs[item] + ";"}
              </span>
            ),
          )}
        <span className="StyleAttribSpan SecondaryText">
          <b>{"}"}</b>
        </span>
      </div>
    );
  };

  render() {
    const themeClasses = "Themed";

    return (
      <div className="StyleViewDiv HighPanel" onClick={this.handleClick}>
        {pseudoClasses.map((item, index) => (
          <div className="StyleViewItemDiv" key={index}>
            <input
              id={"Input " + item}
              className={"Input NoSelect " + themeClasses + " " + item}
              placeholder="Sample Input"
              readOnly
              disabled
            />
            {this.renderCSS("Input " + item, item !== "" ? ["Input "] : [])}
          </div>
        ))}

        {pseudoClasses.map((item, index) => (
          <div className="StyleViewItemDiv" key={index}>
            <div className="CheckboxDiv Sample">
              <input
                id={"Checkbox " + item}
                className={"Checkbox " + themeClasses + " " + item}
                type="checkbox"
                checked={true}
                readOnly
                disabled
              />
              <label className="Label SecondaryText NoSelect" htmlFor="Checkbox">
                Sample Checkbox
              </label>
            </div>
            {this.renderCSS("Checkbox " + item, item !== "" ? ["Checkbox "] : [])}
          </div>
        ))}

        {pseudoClasses.map((item, index) => (
          <div className="StyleViewItemDiv" key={index}>
            <button id={"PrimaryButton " + item} className={"Button NoSelect " + themeClasses + " " + item} disabled>
              BUTTON 1
            </button>
            {this.renderCSS("PrimaryButton " + item, item !== "" ? ["PrimaryButton "] : [])}
          </div>
        ))}

        {pseudoClasses.map((item, index) => (
          <div className="StyleViewItemDiv" key={index}>
            <button
              id={"SecondaryButton " + item}
              className={"Button Secondary NoSelect " + themeClasses + " " + item}
              disabled
            >
              BUTTON 2
            </button>
            {this.renderCSS(
              "SecondaryButton " + item,
              item !== "" ? ["PrimaryButton " + item, "SecondaryButton "] : ["PrimaryButton " + item],
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default StyleView;
